import { AvayaProvider } from '../../providers/avaya/avaya-provider';
import { GatewayProvider } from '../../providers/gateway/gateway-provider';
export function getProvider(id) {
  switch (id) {
    case 'avaya':
      return AvayaProvider;
    default:
      return GatewayProvider;
  }
}
//# sourceMappingURL=get-provider.js.map
